// Maps

import {
  Map,
  TileLayer,
  LatLngBounds,
  Marker,
  DivIcon,
} from 'leaflet/dist/leaflet-src.esm'

const elements = document.querySelectorAll('.n-map')

for (const element of elements) {
  const str = element.querySelector('.marker-data').innerText
  const json = JSON.parse(str)
  // console.log(json);

  const map = new Map(element.querySelector('.map'))
  const bounds = new LatLngBounds(json)
  map.fitBounds(bounds)

  new TileLayer(
    'https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png',
    {
      Zoom: 14,
      attributon: '',
    },
  ).addTo(map)

  // console.log(json[0].legend);

  element.querySelector('.legend').innerHTML += json[0].legend

  for (let { type, lat, lng, label, text, telephone, email } of json) {
    if (lat && lng) {
      const icon = new DivIcon({
        html: `<svg class="svg" aria-label="icon" width="23" height="36" data-type="${
          type || ''
        }"><use xlink:href="#icon-map"></use></svg>`,
        iconSize: [23, 36],
      })
      label = `<div class="title" class='map-label'>${label}</div>`
      text = text.length > 0 ? `<div class="text">${text}</div>` : ''
      telephone =
        telephone.length > 0 ? `<div class="telephone">${telephone}</div>` : ''
      email =
        email.length > 0
          ? `<div class="email"><a href="mailto:${email}">${email}</a></div>`
          : ''
      new Marker([lat, lng], { icon })
        .bindPopup(`${label}${text}${telephone}${email}`, {
          className: `marker-popup-${type}`,
        })
        .addTo(map)
    }
  }

  map.scrollWheelZoom.disable()

  map.on('click', () => {
    if (map.scrollWheelZoom.enabled()) {
      map.scrollWheelZoom.disable()
    } else {
      map.scrollWheelZoom.enable()
    }
  })
}
